import { render, staticRenderFns } from "./SendDocumentsToManager.vue?vue&type=template&id=2282624c&"
import script from "./SendDocumentsToManager.vue?vue&type=script&lang=js&"
export * from "./SendDocumentsToManager.vue?vue&type=script&lang=js&"
import style0 from "./SendDocumentsToManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/evolvo/klientai.cramo.lt/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
